import { FC } from 'react'
import { Row, Col, Breadcrumb, Button, Image } from '@/client/components'
import * as S from './styles'
import { HeroProps } from '../types'

export const Hero: FC<HeroProps> = ({ breadcrumb, title, subtitle, hero_image, tag, label_button }) => (
  <S.Hero>
    <S.ImageWrapper>
      <Image
        hasBreakpoint
        imageData={hero_image}
        style={{ display: 'block', width: '100%', height: 'auto' }}
        priority
      />
    </S.ImageWrapper>

    <S.InnerHero>
      <Row>
        <Col>
          <Breadcrumb pages={breadcrumb} inverse />

          <S.MainHero>
            <S.Badge>{tag}</S.Badge>
            <S.Title>{title}</S.Title>
            <S.Subtitle>{subtitle}</S.Subtitle>
            <Button kind='warning' onClick={() => {}}>
              {label_button}
            </Button>
          </S.MainHero>
        </Col>
      </Row>
    </S.InnerHero>
  </S.Hero>
)
